export default __webpack_public_path__ + "static/media/side3.f55a908f.svg";